module.exports = __webpack_public_path__ + "img/Grugknuckle-Logo-dark.dcd1b5f8.svg";